import { render, staticRenderFns } from "./CustomInputView.vue?vue&type=template&id=d866e54a&scoped=true&"
import script from "./CustomInputView.vue?vue&type=script&lang=ts&"
export * from "./CustomInputView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d866e54a",
  null
  
)

export default component.exports